import React from 'react';
import { Link, Redirect, useLocation } from 'react-router-dom';

/**
 * Displays a link (or immediately redirects) back into a GearOrder page.
 *
 * The key to getting back into the order is to pass a gearOrder object to the link's to.state value.
 * This will be used when the Order component mounts instead of having to start from scratch.
 * 
 * The gearOrder object is retrieved from location.state, meaning the same 'to.state' process was likely
 * used to navigate to the current page.
 * 
 * @param redirect Whether to immediately redirect instead of displaying a link
 * @param pathname The path to use if the default of `/order/new/panels` is to be overridden
 * @param title The link's title. Defaults to "Return to Order" if not provided.
 * @param children The link's children to render if overriding the default "fa fa-arrow-left" link.
 * @param props Any other props (like style, onClick, etc.) to pass to the Link
 */
const ReturnToOrder = ({ redirect, pathname, title, children, ...props }) => {
	const location = useLocation();
	const gearOrder = location?.state?.gearOrder;

	if (redirect && gearOrder) {
		return (
			<Redirect
				to={{
					pathname: pathname || `/order/new/panels`,
					state: {
						forwardFrom: 'bundles',
						gearOrder
					}
				}}
			/>
		);
	}

	return (
		<Link
			to={{
				pathname: pathname || `/order/new/panels`,
				state: {
					forwardFrom: 'bundles',
					gearOrder
				}
			}}
			title={title || 'Return to Order'}
			{...props}
		>
			{children ? (
				children
			) : (
				<>
					<span className="fa fa-arrow-left" aria-hidden="true"></span> Return to Order
				</>
			)}
		</Link>
	);
};

export default ReturnToOrder;
